export default __webpack_public_path__ + "static/media/svg-1.c80def19.svg";